// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1Dd3P","footer":"ModalUpdate_footer__-WIwy"};